// Translation strings for EN / ET
export const translations = {
  en: {
    nav: {
      story: "Our Story",
      details: "Details",
      schedule: "Schedule",
      gallery: "Gallery",
      stay: "Stay",
      rsvp: "RSVP",
      registry: "Gifts",
      faq: "FAQ",
      contact: "Contact",
      inspiration: "Inspiration",
      menu: "Menu",
    },
    hero: {
      saveTheDate: "Save the Date",
      volume: "Vol. I — Tallinn",
      and: "&",
      dateLabel: "The Tenth of October",
      yearLabel: "Two Thousand Twenty-Six",
      location: "Tallinn · Estonia",
      quoteEyebrow: "A Story That Begins With",
      quote: "\u201CIt\u2019s a love story.\u201D \u2014 TS",
      countdown: { days: "Days", hours: "Hours", minutes: "Minutes", seconds: "Seconds" },
      marquee: ["An Autumn Wedding", "Tallinn · Estonia", "10 . 10 . 2026", "#CarmenJaKerbert", "Forever Begins Here"],
    },
    story: {
      chapter: "Chapter One",
      heading: ["Our ", "love story", "."],
      p1: "Sincere and unconditional love holds the greatest power — it can move mountains and carry you under its protective wing through all of life's highs and lows.",
      p2: "Kerbert and Carmen's love story began 10 years ago, when they were just 14 and 15 years old.",
      p3: "From teamwork, trust, care, mutual support and the call of the heart, a wonderful relationship has grown — one that has carried them to the shores of marriage, to sail on hand in hand, inseparable, toward a bright future full of love.",
      timeline: [
        { y: "2016", e: "First Look" },
        { y: "10y", e: "Together" },
        { y: "2026", e: "Forever" },
      ],
      caption: "Roll 01 · Frame 14",
    },
    details: {
      chapter: "Chapter Two",
      heading: ["Two acts of ", "one evening", "."],
      sub: "Join us as the autumn light goes long and gold across the harbour.",
      act1Label: "Act I · Ceremony",
      act2Label: "Act II · Reception",
      beginsAt: "Begins At",
      where: "Where",
    },
    schedule: {
      chapter: "Chapter Three",
      heading: ["The order of the ", "evening", "."],
      sub: "A rough itinerary. The main plan is to celebrate, enjoy and spend a day full of love together.",
      subNote: "* Schedule may shift during the evening.",
      items: [
        { key: "gathering", time: "2:30 PM", title: "Arrival for the Ceremony", desc: "Maarja-Magdaleena Church, Tallinn. Please arrive 20-30 minutes before the ceremony to allow enough time for parking and a calm walk in — this helps us start on time." },
        { key: "ceremony", time: "3:00 PM", title: "Ceremony", desc: "The exchange of vows." },
        { key: "arrival", time: "5:00 PM", title: "Arrival at the Cruise Terminal", desc: "Welcome drinks at the venue." },
        { key: "dinner", time: "6:00 PM", title: "Dinner", desc: "Enjoy the meal!" },
        { key: "firstdance", time: "7:15 PM", title: "First Dance", desc: "The newlyweds' first dance." },
        { key: "band", time: "7:15 PM", title: "Band — First Set", desc: "Party, dancing & fun with the band." },
        { key: "cake", time: "10:15 PM", title: "Cake", desc: "Our sweet hour." },
        { key: "disco", time: "12:00 AM", title: "Disco", desc: "Dance until late." },
      ],
    },
    gallery: {
      chapter: "Chapter Four",
      heading: ["A few of our ", "favourite frames", "."],
      tag: ["Tag your photos ", " so we can relive the day through your eyes."],
      soonEyebrow: "Photos coming soon",
      soonTitle: "The frames are still being chosen.",
      soonBody: "We're gathering our favourite moments — check back closer to the day.",
    },
    rsvp: {
      chapter: "Chapter Five",
      heading: ["Will you ", "join us?"],
      sub: "Kindly respond by the first of September, twenty twenty-six. We can\u2019t wait to celebrate with you.",
      replyBy: "Reply by",
      replyByValue: "Sep 1, 2026",
      questions: "Questions?",
      contactEmail: "carmen.kerbert@gmail.com",
      fullName: "Full Name",
      fullNamePh: "Your full name",
      email: "Email",
      emailPh: "you@example.com",
      attending: "Will you be attending?",
      yes: "Joyfully accepts",
      no: "Regretfully declines",
      guests: "Number of Guests",
      plusOne: "I'm bringing a +1",
      plusOneName: "Name of your +1",
      plusOneNamePh: "Full name of your guest",
      meal: "Meal Preference",
      mealChoose: "Choose...",
      meals: { chicken: "Chicken", beef: "Beef", fish: "Fish", pork: "Pork", vegetarian: "Vegetarian", vegan: "Vegan" },
      song: "Song Request",
      optional: "(optional)",
      songPh: "A song that will get you on the dance floor",
      origin: "Where are you travelling from?",
      city: "City",
      cityPh: "e.g. Tallinn",
      country: "Country",
      countryPh: "e.g. Estonia",
      note: "Note to the Couple",
      notePh: "Leave a sweet little note...",
      footer: "We promise to read every note before the big day.",
      submit: "Send RSVP",
      submitting: "Sending...",
      successEyebrow: "RSVP Received",
      successTitle: "Thank you — your reply is recorded.",
      successBody: "A confirmation has been logged in our little book of yeses. We\u2019ll be in touch closer to the day.",
      submitAnother: "Submit Another RSVP",
      errorMissing: "Please share your name and email.",
      errorPlusOneName: "Please add your +1's name.",
      errorGeneric: "Something went wrong. Please try again.",
      toastSuccess: "Thank you — your RSVP is in.",
    },
    registry: {
      chapter: "Chapter Six",
      heading: ["Your presence is the ", "best gift", "."],
      sub: "Your presence means the most to us. If you\u2019d still like to bring a gift, an envelope will do beautifully.",
      ibanTitle: "Florist — flower fund",
      ibanSub: "We kindly ask that no one brings flowers themselves. If you'd like to bring us joy, you can send a small amount to our florist for the flowers below — or, instead, surprise us with lottery tickets.",
      copy: "Copy IBAN",
      copied: "Copied!",
      accounts: [
        { name: "Fiorissima OÜ", iban: "EE78 7700 7710 0317 3085" },
      ],
    },
    faq: {
      chapter: "Chapter Seven",
      heading: ["The ", "small print", "."],
      sub: "A few questions we\u2019ve been asked more than once.",
      items: [
        { q: "What is the dress code?", a: "Dress code is Black-Tie Optional / Formal. Our colour palette leans into warm sunset tones with elegant black as a companion. We'd be delighted if you factored these into your outfit — there's no colour exam, but a shared palette makes the photos especially beautiful. Colours and outfit inspiration live below." },
        { q: "Can I bring a partner?", a: "If you received the RSVP link on your own, you can indicate on the form that you\u2019d like to bring a partner and enter their full name. Your partner\u2019s attendance is confirmed once we\u2019ve reviewed and approved it." },
        { q: "Are children welcome?", a: "On our wedding day we're hosting a grown-ups' celebration. For the little ones, we kindly ask that you arrange a lovely babysitter so parents can fully enjoy the party, the small moments and the dance floor." },
        { q: "How do I get there?", a: "The ceremony takes place at Maarja-Magdaleena Church in Tallinn, and the reception is at the Old City Cruise Terminal. Full addresses and map links are in the \u201CEvent Details\u201D section above." },
        { q: "Where can I park?", a: "There are several parking options near both the ceremony and the reception. You'll find full details in the \u201CParking\u201D section above." },
        { q: "Is transportation provided?", a: "Transportation is not provided. If you need help arranging a taxi or shared ride, please contact us by email and we\u2019ll do our best to help." },
        { q: "Where do you recommend staying?", a: "See the \u201CWhere to Stay\u201D section above for our hand-picked hotels — all within a short walk of the reception venue." },
        { q: "What if I can\u2019t attend?", a: "We\u2019ll miss you. Please still RSVP so we can keep our planning on track and toast you from afar." },
      ],
    },
    stay: {
      chapter: "Where to Stay",
      heading: ["A few of our ", "favourite hotels", "."],
      sub: "All within a short walk of the reception venue at the Old City Harbour. Book early — Tallinn fills up in October.",
      viewHotel: "View hotel →",
      distanceLabel: "Distance",
      priceLabel: "Price",
      priceLegend: "€ affordable · €€ mid · €€€ upscale",
    },
    guestmap: {
      chapter: "Chapter Five · a",
      heading: ["From ", "far & near", "."],
      sub: "A love letter to every guest crossing land, water and sky to be with us on October 10th.",
      home: "The Wedding",
      travelling: "Travelling from",
      guests: "Guests",
      cities: "Cities",
      countries: "Countries",
      guestsLabel: "guests",
      empty: "The first pin is Tallinn — waiting for yours to appear.",
      emptyEyebrow: "Waiting on you",
      footer: "Add your city on the RSVP form and watch a warm spark appear on the map.",
      reset: "Reset view",
    },
    contact: {
      chapter: "Final Chapter",
      heading: ["We can\u2019t ", "wait", " to see you."],
      sub: "Reach out anytime — for travel tips, late RSVPs, song requests, or just to say hi.",
      emailLabel: "Email",
      phoneLabel: "Phone",
      followLabel: "Follow",
    },
    footer: {
      tag: "10 . 10 . 2026 · Tallinn · Estonia",
      made: "Made with love · A wedding website",
    },
    parking: {
      nav: "Parking",
      chapter: "Getting There",
      heading: ["Parking & ", "arrival", "."],
      sub: "A little guidance so arriving is effortless — at both the church and the reception.",
      mustamaeTitle: "At the Church — Mustamäe",
      mustamaeText: "Free parking is available around Maarja-Magdaleena Church. Please follow the parking map below and leave room for other guests.",
      mapCta: "View parking map",
      terminalTitle: "At the Reception — Cruise Terminal",
      terminalText: "To drive into the Old City Harbour area you must be pre-registered. Please submit your name, personal ID code and car plate below and we'll add you to the access list.",
      formName: "Full Name",
      formNamePh: "Name on the vehicle",
      formCode: "Personal ID Code",
      formCodePh: "e.g. 39001010000",
      formPlate: "Car Plate Number",
      formPlatePh: "e.g. 123 ABC",
      submit: "Register My Car",
      submitting: "Sending...",
      successTitle: "You're on the list!",
      successBody: "Your car has been registered for the Cruise Terminal. Drive safe — see you soon.",
      another: "Register another car",
      errorMissing: "Please fill in your name, ID code and plate.",
      errorGeneric: "Something went wrong. Please try again.",
      toastSuccess: "Car registered — see you at the harbour!",
    },
    inspiration: {
      eyebrow: "Inspiration",
      title: "Colour Palette",
      intro: "A gentle guide for what to wear on the day. Our dress code is Black Tie Optional / Formal — elegant and celebratory attire, where a black tie or tuxedo is welcome but not required. A classic dark suit, an elegant floor-length or midi evening dress, or another tasteful evening outfit works beautifully too. We've put together a wedding colour palette to draw inspiration from. Feel free to pick anything from the tones below — warm sunset shades, bold oranges and pinks, or calmer earthy greens and browns. Our palette also embraces elegant black, especially lovely for men's suits. Most importantly, wear what makes you feel wonderful — a shared colour mood just creates a beautiful whole and makes the photos especially harmonious.",
      primary: "Primary Colours",
      secondary: "Secondary Colours",
      accent: "Accent Colours",
      whiteWarning: "Reserved for the couple",
      photosEyebrow: "Mood Board",
      photosTitle: "Style Inspiration",
      photosSub: "Outfit and mood ideas to inspire your look.",
      photoSoon: "Photo soon",
      optional: "(optional)",
    },
    admin: {
      back: "Back to site",
      private: "Private",
      heading: ["The Book of ", "Yeses", "."],
      refresh: "Refresh",
      stats: { responses: "Responses", attending: "Attending", declined: "Declined", guests: "Total Guests" },
      table: { name: "Name", email: "Email", attending: "Attending", guests: "Guests", meal: "Meal", song: "Song", note: "Note", submitted: "Submitted" },
      empty: "No RSVPs yet — the book is empty.",
      joyful: "Joyfully",
      regrets: "Regrets",
      confirmDelete: "Delete this RSVP?",
      deleted: "RSVP deleted",
      deleteFailed: "Could not delete RSVP",
      loadFailed: "Failed to load RSVPs",
    },
  },

  et: {
    nav: {
      story: "Meie lugu",
      details: "Üksikasjad",
      schedule: "Ajakava",
      gallery: "Galerii",
      stay: "Ööbimine",
      rsvp: "Kinnita",
      registry: "Kingitused",
      faq: "KKK",
      contact: "Kontakt",
      inspiration: "Inspiratsioon",
      menu: "Menüü",
    },
    hero: {
      saveTheDate: "Pane kuupäev kirja",
      volume: "Köide I — Tallinn",
      and: "&",
      dateLabel: "Kümnes oktoober",
      yearLabel: "Kaks tuhat kakskümmend kuus",
      location: "Tallinn · Eesti",
      quoteEyebrow: "Lugu, mis algab nõnda",
      quote: "\u201EIt\u2019s a love story.\u201C \u2014 TS",
      countdown: { days: "Päeva", hours: "Tundi", minutes: "Minutit", seconds: "Sekundit" },
      marquee: ["Sügisene pulmapäev", "Tallinn · Eesti", "10 . 10 . 2026", "#CarmenJaKerbert", "Igavik algab siit"],
    },
    story: {
      chapter: "Esimene peatükk",
      heading: ["Meie ", "armastuslugu", "."],
      p1: "Siiral ja tingimusteta armastusel on suurim võim, see võib paigast liigutada mägesid ja kanda sind oma kaitsva tiiva all läbi elu tõusude ja mõõnade.",
      p2: "Kerberti ja Carmeni armastuslugu sai alguse 10 aastat tagasi, kui nad olid vaid 14 ja 15-aastased noored.",
      p3: "Koostööst, usaldusest, hoolimisest, üksteise toetamisest ja südame kutsest on tänaseks välja kasvanud imeline suhe, mis on kandnud nad abieluranda, et siit käsikäes, lahutamatutena, elumere lainetel helge ja armastusest tulvil tuleviku poole purjetada.",
      timeline: [
        { y: "2016", e: "Esimene pilk" },
        { y: "10a", e: "Koos" },
        { y: "2026", e: "Igavesti" },
      ],
      caption: "Rull 01 · Kaader 14",
    },
    details: {
      chapter: "Teine peatükk",
      heading: ["Ühe õhtu ", "kaks vaatust", "."],
      sub: "Liitu meiega, kui sügisene valgus venib pikaks ja kuldseks üle sadama.",
      act1Label: "I vaatus · Tseremoonia",
      act2Label: "II vaatus · Pidu",
      beginsAt: "Algab kell",
      where: "Asukoht",
    },
    schedule: {
      chapter: "Kolmas peatükk",
      heading: ["Õhtu ", "käik", "."],
      sub: "Üldine ajakava. Peamine plaan on tähistada, nautida ja veeta koos üks armastust täis päev.",
      subNote: "* Ajakava võib õhtu jooksul muutuda.",
      items: [
        { key: "gathering", time: "14:30", title: "Saabumine laulatuseks", desc: "Maarja-Magdaleena kirik, Tallinn. Palume saabuda 20-30 minutit enne tseremoonia algust, et jääks piisavalt aega parkimiseks ja rahulikult kohale jõudmiseks — nii saame tseremooniaga õigel ajal alustada." },
        { key: "ceremony", time: "15:00", title: "Laulatus", desc: "Pühalik tõotuste vahetamine." },
        { key: "arrival", time: "17:00", title: "Saabumine Kruiisiterminali", desc: "Tervitusjook peokohas." },
        { key: "dinner", time: "18:00", title: "Söömine", desc: "Head isu!" },
        { key: "firstdance", time: "19:15", title: "Avatants", desc: "Noorpaari esimene tants." },
        { key: "band", time: "19:15", title: "Bändi esimene set", desc: "Pidu, tants & rõõm bändi saatel." },
        { key: "cake", time: "22:15", title: "Tort", desc: "Meie magus tund." },
        { key: "disco", time: "00:00", title: "Disko", desc: "Tantsime hiliste tundideni." },
      ],
    },
    gallery: {
      chapter: "Neljas peatükk",
      heading: ["Mõned meie ", "lemmikkaadrid", "."],
      tag: ["Märgista oma pildid ", ", et saaksime päeva uuesti läbi sinu silmade näha."],
      soonEyebrow: "Pildid tulekul",
      soonTitle: "Meie lemmikkaadrid on veel valimisel.",
      soonBody: "Kogume kokku parimad hetked — vaata siia lähemale pulmapäevale tagasi.",
    },
    rsvp: {
      chapter: "Viies peatükk",
      heading: ["Kas tuled ", "meiega?"],
      sub: "Palun kinnita osavõtt hiljemalt esimeseks septembriks 2026. Me ootame südamest sinuga koos tähistada.",
      replyBy: "Vasta hiljemalt",
      replyByValue: "1. sept 2026",
      questions: "Küsimused?",
      contactEmail: "carmen.kerbert@gmail.com",
      fullName: "Täisnimi",
      fullNamePh: "Sinu täisnimi",
      email: "E-post",
      emailPh: "sina@näide.ee",
      attending: "Kas tuled pulma?",
      yes: "Tulen rõõmuga",
      no: "Kahjuks ei saa",
      guests: "Külaliste arv",
      plusOne: "Võtan kaaslase (+1)",
      plusOneName: "Kaaslase nimi",
      plusOneNamePh: "Sinu kaaslase täisnimi",
      meal: "Toidueelistus",
      mealChoose: "Vali...",
      meals: { chicken: "Kana", beef: "Veiseliha", fish: "Kala", pork: "Sealiha", vegetarian: "Taimetoit", vegan: "Veganlik" },
      song: "Laulusoov",
      optional: "(soovi korral)",
      songPh: "Lugu, mis paneb sind tantsupõrandale",
      origin: "Kust sa kohale tuled?",
      city: "Linn",
      cityPh: "nt Tallinn",
      country: "Riik",
      countryPh: "nt Eesti",
      note: "Sõnum noortele",
      notePh: "Jäta meile väike sõnum...",
      footer: "Lubame iga sõnumi enne suurt päeva läbi lugeda.",
      submit: "Saada kinnitus",
      submitting: "Saadan...",
      successEyebrow: "Kinnitus vastu võetud",
      successTitle: "Aitäh — sinu vastus on kirjas.",
      successBody: "Sinu jah on lisatud meie väikesesse jah-de raamatusse. Võtame ühendust pulmapäevale lähemal.",
      submitAnother: "Saada veel üks kinnitus",
      errorMissing: "Palun lisa oma nimi ja e-post.",
      errorPlusOneName: "Palun lisa oma kaaslase nimi.",
      errorGeneric: "Midagi läks valesti. Proovi uuesti.",
      toastSuccess: "Aitäh — sinu kinnitus on käes.",
    },
    registry: {
      chapter: "Kuues peatükk",
      heading: ["Sinu kohalolu on ", "parim kingitus", "."],
      sub: "Teie kohalolek on meile kõige tähtsam. Kui soovite meid siiski kingitusega rõõmustada, võiks see mahtuda ümbrikusse.",
      ibanTitle: "Florist — lillede konto",
      ibanSub: "Palume, et keegi ise lilli kaasa ei tooks. Kui soovid meid rõõmustada, saad kanda väikese summa meie floristile lillede jaoks (konto allpool) — või üllata meid hoopis lotopiletitega.",
      copy: "Kopeeri IBAN",
      copied: "Kopeeritud!",
      accounts: [
        { name: "Fiorissima OÜ", iban: "EE78 7700 7710 0317 3085" },
      ],
    },
    faq: {
      chapter: "Seitsmes peatükk",
      heading: ["Väike ", "peenkiri", "."],
      sub: "Mõned küsimused, mida on rohkem kui korra küsitud.",
      items: [
        { q: "Milline on riietumisstiil?", a: "Riietusstiiliks on Black-Tie Optional / Formal. Meie peo värvipaletti kuuluvad päikeseloojangu toonid, lisaks elegantne must. Oleme rõõmsad, kui saaksid neid oma riietuse valikul arvesse võtta. Värvieksamit küll ei tule, aga ühtne peomeeleolu teeb fotod eriti ilusaks. Pulmavärvid ja riietuse inspiratsioonid leiad altpoolt." },
        { q: "Kas võin tulla kaaslasega?", a: "Kui oled registreerimislingi saanud üksinda, võid vormil märkida soovi tulla kaaslasega ja lisada tema täisnime. Kaaslase osalemine on kinnitatud pärast meiepoolset kinnitust." },
        { q: "Kas lapsed on oodatud?", a: "Pulmapäeval ootame tähistama suuri pidulisi. Pisipõnnidele palume selleks õhtuks leida mõne toreda hoidja, et vanemad saaksid rahulikult pidu, häid hetki ja tantsupõrandat nautida." },
        { q: "Kuidas kohale saab?", a: "Laulatus toimub Tallinnas Maarja-Magdaleena kirikus ning peokoht on Vanasadama Kruiisiterminalis. Täpsed aadressid ja kaardilingid leiad sektsioonist \u201ESündmuse detailid\u201C ülevalpool." },
        { q: "Kus saab parkida?", a: "Nii tseremooniapaiga kui ka peokoha läheduses on mitmeid parkimisvõimalusi. Täpsema info leiad jaotisest \u201EParkimine\u201C ülevalpool." },
        { q: "Kas transport on korraldatud?", a: "Transporti me ei korralda. Kui vajad abi takso või ühissõidu leidmisel, võta meiega e-posti teel ühendust ja aitame nii palju kui suudame." },
        { q: "Kus soovitate ööbida?", a: "Vaata jaotist \u201EKus ööbida\u201C ülevalpool — leiad sealt meie soovitatud hotellid, mis kõik on lühikese jalutuskäigu kaugusel õhtusöögikohast." },
        { q: "Mida teha, kui ma ei saa tulla?", a: "Me jääme sind igatsema. Palun kinnita siiski osavõtt, et saaksime planeerida ja sind kaugelt tervitada." },
      ],
    },
    stay: {
      chapter: "Kus ööbida",
      heading: ["Mõned meie ", "lemmikhotellid", "."],
      sub: "Kõik lühikese jalutuskäigu kaugusel Vanasadamast, kus toimub õhtusöök. Broneeri varakult — oktoobris on Tallinn tihedalt broneeritud.",
      viewHotel: "Vaata hotelli →",
      distanceLabel: "Kaugus",
      priceLabel: "Hind",
      priceLegend: "€ soodne · €€ keskmine · €€€ luksuslik",
    },
    guestmap: {
      chapter: "Viies peatükk · a",
      heading: ["Kaugelt & ", "lähedalt", "."],
      sub: "Armastuskiri kõigile, kes ületavad maad, merd ja taevast, et 10. oktoobril meiega olla.",
      home: "Pulmapäev",
      travelling: "Saabub",
      guests: "Külalisi",
      cities: "Linna",
      countries: "Riiki",
      guestsLabel: "külalist",
      empty: "Esimene täpp on Tallinnas — ootame, et sinu oma sinna kõrvale ilmuks.",
      emptyEyebrow: "Ootame sind",
      footer: "Lisa oma linn RSVP vormil ja vaata, kuidas kaardile süttib soe säde.",
      reset: "Lähtesta vaade",
    },
    contact: {
      chapter: "Viimane peatükk",
      heading: ["Me ei jõua ", "ära oodata", " sinuga kohtumist."],
      sub: "Võta meiega ühendust — reisinõu, hilise kinnituse, laulusoovi või lihtsalt tere ütlemise jaoks.",
      emailLabel: "E-post",
      phoneLabel: "Telefon",
      followLabel: "Jälgi",
    },
    footer: {
      tag: "10 . 10 . 2026 · Tallinn · Eesti",
      made: "Tehtud armastusega · Pulmaveebileht",
    },
    parking: {
      nav: "Parkimine",
      chapter: "Kohalejõudmine",
      heading: ["Parkimine & ", "saabumine", "."],
      sub: "Väike juhis, et saabumine oleks muretu — nii kirikus kui peol.",
      mustamaeTitle: "Kirikus — Mustamäe",
      mustamaeText: "Maarja-Magdaleena kiriku ümbruses on tasuta parkimine. Palun järgi allolevat parkimisplaani ja jäta ruumi ka teistele külalistele.",
      mapCta: "Vaata parkimisplaani",
      terminalTitle: "Peol — Kruiisiterminal",
      terminalText: "Vanasadama alale sissesõiduks pead olema eelnevalt registreeritud. Palun sisesta allpool oma nimi, isikukood ja auto number ning lisame su pääsunimekirja.",
      formName: "Nimi",
      formNamePh: "Sõiduki eest vastutaja nimi",
      formCode: "Isikukood",
      formCodePh: "nt 39001010000",
      formPlate: "Auto number",
      formPlatePh: "nt 123 ABC",
      submit: "Registreeri auto",
      submitting: "Saadan...",
      successTitle: "Oled nimekirjas!",
      successBody: "Sinu auto on Kruiisiterminali registreeritud. Turvalist sõitu — kohtumiseni!",
      another: "Registreeri veel üks auto",
      errorMissing: "Palun täida nimi, isikukood ja auto number.",
      errorGeneric: "Midagi läks valesti. Proovi uuesti.",
      toastSuccess: "Auto registreeritud — kohtumiseni sadamas!",
    },
    inspiration: {
      eyebrow: "Inspiratsioon",
      title: "Värvipalett",
      intro: "Väike juhis, mida pulmapäeval selga panna. Meie riietusstiiliks on Black Tie Optional / Formal – see tähendab elegantset ja pidulikku riietust, kus must lips ja smoking on teretulnud, kuid mitte kohustuslikud. Sobib ka klassikaline tume ülikond, elegantne pikk või midi-pikkuses õhtukleit või muu maitsekas õhtune riietus. Oleme loonud pulmavärvide paleti, millest saad inspiratsiooni ammutada. Vali julgelt midagi allolevatest toonidest – soojad päikeseloojangu värvid, julged oranžid ja roosad, aga ka rahulikumad naturaalsed rohelised ja pruunid toonid. Lisaks kuulub meie värvipaletti elegantne must, mida võib julgelt kasutada, eriti meeste ülikondade puhul. Kõige olulisem on, et tunneksid end hästi – ühtne värvimeeleolu aitab lihtsalt luua kauni terviku ja muudab fotod eriti harmooniliseks.",
      primary: "Põhivärvid",
      secondary: "Sekundaarsed värvid",
      accent: "Lisavärvid",
      whiteWarning: "Pruutpaarile",
      photosEyebrow: "Meeleoluplaan",
      photosTitle: "Stiiliinspiratsioon",
      photosSub: "Rõivastuse ja meeleolu ideed sinu stiili inspireerimiseks.",
      photoSoon: "Foto tulekul",
      optional: "(valikuline)",
    },
    admin: {
      back: "Tagasi lehele",
      private: "Privaatne",
      heading: ["Jah-de ", "raamat", "."],
      refresh: "Värskenda",
      stats: { responses: "Vastuseid", attending: "Tulijaid", declined: "Ei saa", guests: "Külalisi kokku" },
      table: { name: "Nimi", email: "E-post", attending: "Tuleb", guests: "Külalisi", meal: "Toit", song: "Lugu", note: "Sõnum", submitted: "Saadetud" },
      empty: "Veel ühtegi kinnitust pole — raamat on tühi.",
      joyful: "Rõõmuga",
      regrets: "Ei saa",
      confirmDelete: "Kustutada see kinnitus?",
      deleted: "Kinnitus kustutatud",
      deleteFailed: "Kinnituse kustutamine ebaõnnestus",
      loadFailed: "Kinnituste laadimine ebaõnnestus",
    },
  },
};
